<template>
  <v-card style="min-height: 90vh">
    <v-toolbar
      style="font-weight: bold"
      color="#58595b"
      dense
      dark
      class="mb-0"
    >
      Lead - # <span style="font-weight: bold"> {{ formData.id }}</span>
      <v-spacer></v-spacer>
      <input
        style="opacity: 0"
        type="text"
        id="clipboardText"
        v-model="clipboardTextData"
      />
      <v-btn
        v-if="formOpen && formData.hasOwnProperty('id')"
        :loading="deleting"
        small
        raised
        color="error"
        class="mr-2"
        @click="deleteItem()"
      >
        Archive
      </v-btn>
      <v-btn small raised color="success" :loading="saving" @click="save()">
        Save & Close
      </v-btn>
      <v-btn icon @click="$router.push('/admin/leads')">
        <v-icon> mdi-close </v-icon>
      </v-btn>
    </v-toolbar>
    <v-card flat>
      <v-card-text>
        <v-form ref="leadsForm">
          <v-layout class="salesForm" key="form" wrap justify-center>
            <!-- Lead From Section -->
            <v-flex class="mb-4" xs12 md6>
              <v-card class="ma-2" elevation="5" style="height: 100%">
                <v-toolbar
                  color="#325181"
                  style="font-weight: bold"
                  dense
                  dark
                  class="mb-0"
                >
                  Lead From
                </v-toolbar>
                <v-card-text>
                  <v-layout row wrap>
                    <v-flex xs6 class="px-1 mb-1">
                      <v-autocomplete
                        v-model="formData.business_id"
                        label="Impact Buyer"
                        :items="entities"
                        item-text="name"
                        item-value="id"
                        hide-details
                        @change="updateEntityData"
                      ></v-autocomplete>
                    </v-flex>
                    <v-flex xs6 class="px-1 mb-1">
                      <v-text-field
                        label="Buyer Type"
                        hide-details
                        readonly
                        v-model="formData.impactBuyerType"
                      >
                      </v-text-field>
                    </v-flex>
                    <v-flex xs6 class="px-1 mb-1">
                      <v-text-field
                        label="Name"
                        hide-details
                        v-model="formData.leadFromName"
                        @click:append="copyField(formData.leadFromName)"
                        append-icon="mdi-content-copy"
                      >
                      </v-text-field>
                    </v-flex>
                    <v-flex xs6 class="px-1 mb-1">
                      <v-text-field
                        label="Phone"
                        hide-details
                        v-model="formData.leadFromPhone"
                        @click:append="copyField(formData.leadFromPhone)"
                        append-icon="mdi-content-copy"
                      >
                      </v-text-field>
                    </v-flex>
                    <v-flex
                      :xs12="formData.leadFromEmail == ''"
                      :xs6="formData.leadFromEmail != ''"
                      class="px-1 mb-1"
                    >
                      <v-text-field
                        label="Email"
                        v-model="formData.leadFromEmail"
                        @click:append="copyField(formData.leadFromEmail)"
                        append-icon="mdi-content-copy"
                        hide-details
                      >
                      </v-text-field>
                    </v-flex>
                    <v-flex xs6 class="px-2">
                      <v-btn
                        :disabled="formData.leadFromEmail == ''"
                        @click="
                          emailIBDialog = true;
                          loadIBEmailPreview();
                        "
                        block
                        color="#325181"
                        dark
                      >
                        Email I.B
                      </v-btn>
                    </v-flex>
                    <v-flex xs12 class="mt-2 mb-0">
                      <div
                        style="
                          width: 100%;
                          text-align: center;
                          font-weight: bold;
                          background: #white;
                          border-radius: 5px;
                          color: white;
                        "
                        class="pa-2"
                      >
                        <span
                          style="font-size: 18pt; float: left; color: #58595b"
                          >Total Enq:
                          <span style="color: #325181">
                            {{ formData.leadFrom_enquiryTotal }}
                          </span>
                        </span>
                        <span style="font-size: 18pt; color: #58595b">
                          Total Rev:

                          <span style="color: #325181">{{
                            formatMoney(formData.leadFrom_revenueTotal)
                          }}</span>
                        </span>

                        <span
                          style="float: right; font-size: 18pt; color: #58595b"
                        >
                          Total $UC:
                          <span style="color: #325181">{{
                            formatMoney(formData.leadFrom_cCTotal)
                          }}</span>
                        </span>
                      </div>
                    </v-flex>
                  </v-layout>
                </v-card-text>
              </v-card>
            </v-flex>
            <!-- Enquiry Details Section -->
            <v-flex class="mb-4" xs12 md6>
              <v-card class="ma-2" elevation="5" style="height: 100%">
                <v-toolbar
                  style="font-weight: bold"
                  color="#4cc7e8"
                  dense
                  dark
                  class="mb-0"
                >
                  Lead For ($)
                </v-toolbar>
                <v-card-text>
                  <v-layout row wrap>
                    <v-flex xs6 class="px-1 mb-1">
                      <v-autocomplete
                        label="Supplier Name"
                        v-model="formData.leadFor_business_id"
                        :items="suppliers"
                        item-text="name"
                        item-value="id"
                        hide-details
                        @change="updateSupplierData"
                      >
                      </v-autocomplete>
                    </v-flex>
                    <v-flex xs6 class="px-1 mb-1">
                      <v-text-field
                        label="Supplier Type"
                        v-model="formData.listTitle"
                        readonly
                        hide-details
                      >
                      </v-text-field>
                    </v-flex>

                    <!-- <v-flex xs6 class="px-1 mb-1">
                      <v-text-field
                        label="Tracking #"
                        v-model="formData.callRailPhone"
                        readonly
                        hide-details
                        append-icon="mdi-content-copy"
                        @click:append="copyField(formData.callRailPhone)"
                      >
                      </v-text-field>
                    </v-flex> -->
                    <v-flex xs12 class="px-1 mb-1" style="background: #fffee0">
                      <v-text-field
                        label="Opportunity Summary"
                        v-model="formData.leadSummary"
                        hide-details
                      >
                      </v-text-field>
                    </v-flex>
                    <v-flex xs6 class="px-1 mb-1">
                      <v-text-field
                        label="Web Link (URL Keyword)"
                        v-model="formData.urlKeyword"
                        readonly
                        @click:append="
                          copyField(
                            'https://upstreamnz.co.nz/use/' +
                              formData.urlKeyword
                          )
                        "
                        append-icon="mdi-content-copy"
                        hide-details
                      ></v-text-field>
                    </v-flex>
                    <v-flex
                      v-if="
                        typeof formData.salesEnquiry_id == 'undefined' ||
                          formData.salesEnquiry_id == ''
                      "
                      xs6
                      class="px-2"
                    >
                      <v-btn
                        @click="
                          emailASConfirmContactDialog = true;
                          confirmContactDetailsAS();
                        "
                        block
                        color="#4cc7e8"
                        dark
                      >
                        Email A.S
                      </v-btn>
                    </v-flex>
                    <v-flex xs12 class="mt-2 mb-0">
                      <div
                        style="
                          width: 100%;
                          text-align: center;
                          font-weight: bold;
                          background: #white;
                          border-radius: 5px;
                          color: white;
                        "
                        class="pa-2"
                      >
                        <span
                          style="font-size: 18pt; float: left; color: #58595b"
                          >Total Enq:
                          <span style="color: #4cc7e8">{{
                            formData.leadFor_enquiryTotal
                          }}</span>
                        </span>
                        <span style="font-size: 18pt; color: #58595b">
                          Total Rev:

                          <span style="color: #4cc7e8">
                            {{ formatMoney(formData.leadFor_revenueTotal) }}
                          </span>
                        </span>

                        <span
                          style="float: right; font-size: 18pt; color: #58595b"
                        >
                          Total $UC:
                          <span style="color: #4cc7e8">{{
                            formatMoney(formData.leadFor_cCTotal)
                          }}</span>
                        </span>
                      </div>
                    </v-flex>
                  </v-layout>
                </v-card-text>
              </v-card>
            </v-flex>
            <!-- History Section -->
            <v-flex class="mb-4" xs12 md6>
              <v-card class="ma-2" elevation="5" style="height: 100%">
                <v-toolbar
                  style="font-weight: bold"
                  color="grey darken-2"
                  dense
                  dark
                  class="mb-0"
                >
                  Milestones
                  <v-spacer></v-spacer>
                  <span class="pr-2">Status</span>
                  <v-select
                    style="max-width: 200px"
                    label="Status"
                    hide-details
                    light
                    solo
                    v-model="formData.status"
                    :items="leadStatusList"
                    @change="updateStatus()"
                  ></v-select>
                </v-toolbar>
                <v-card-text>
                  <v-layout row wrap>
                    <v-flex xs4 class="px-1 mb-1">
                      <datepicker
                        :sentDate="this.formData.createdDate"
                        label="Card Created"
                        @dateChanged="updateCreatedDate"
                      ></datepicker>
                    </v-flex>
                    <v-flex xs4 class="px-1 mb-1">
                      <datepicker
                        :sentDate="this.formData.actionTaken"
                        label="Action Taken"
                        @dateChanged="updateActionTaken"
                      ></datepicker>
                    </v-flex>
                    <v-flex xs4 class="px-1 mb-1">
                      <datepicker
                        :sentDate="this.formData.soundingPositive"
                        label="Sounding Positive"
                        @dateChanged="updateSoundingPositive"
                      ></datepicker>
                    </v-flex>
                    <v-flex xs4 class="px-1 mb-1">
                      <!-- <v-dialog
                        ref="dialog"
                        v-model="futureFollowUpDialog"
                        :return-value.sync="futureFollowUpDate"
                        persistent
                        lazy
                        full-width
                        width="290px"
                      >
                        <template v-slot:activator="{ on }">
                          <v-text-field
                            v-model="futureFollowUpDate"
                            label="Future Follow Up"
                            prepend-icon="mdi-calendar"
                            readonly
                            v-on="on"
                          ></v-text-field>
                        </template>
                        <v-date-picker v-model="futureFollowUpDate" scrollable>
                          <v-spacer></v-spacer>
                          <v-btn
                            flat
                            color="primary"
                            @click="futureFollowUpDialog = false"
                            >Cancel</v-btn
                          >
                          <v-btn
                            flat
                            color="primary"
                            @click="
                              $refs.dialog.save(futureFollowUpDate);
                              formData.status = 'Future Follow Up';
                            "
                            >OK</v-btn
                          >
                        </v-date-picker>
                      </v-dialog> -->
                      <datepicker
                        :sentDate="this.formData.futureActionDate"
                        label="Future Follow Up"
                        @dateChanged="updateFutureActionDate"
                      ></datepicker>
                    </v-flex>
                    <v-flex xs4>
                      <datepicker
                        :sentDate="this.formData.slimChance"
                        label="Slim Chance"
                        @dateChanged="updateSlimChance"
                      ></datepicker>
                    </v-flex>
                    <v-flex xs4 class="px-1 mb-1">
                      <datepicker
                        :sentDate="this.formData.noOpportunity"
                        label="No Opportunity"
                        @dateChanged="updateNoOpportunity"
                      ></datepicker>
                    </v-flex>

                    <v-flex xs6 class="px-1 mb-1">
                      <v-textarea
                        label="Admin Notes"
                        hide-details
                        rows="7"
                        v-model="formData.leadNotes"
                      >
                      </v-textarea>
                    </v-flex>
                    <v-flex xs6 class="px-1 mb-1">
                      <v-textarea
                        label="Buyer Comments"
                        hide-details
                        rows="7"
                        v-model="formData.customersComments"
                        readonly
                      >
                      </v-textarea>
                    </v-flex>
                    <v-flex
                      v-if="
                        typeof formData.salesEnquiry_id == 'undefined' ||
                          formData.salesEnquiry_id == ''
                      "
                      xs6
                      class="px-2"
                    >
                      <v-btn
                        @click="convertToSale()"
                        block
                        color="#ed2224"
                        dark
                        :loading="convertToSaleLoading"
                      >
                        Convert To Enquiry
                      </v-btn>
                    </v-flex>
                    <!-- TODO: Bridging Leads to a Sales Enquiry -->
                    <!-- <v-flex
                      v-if="
                        typeof formData.salesEnquiry_id == 'undefined' ||
                          formData.salesEnquiry_id == ''
                      "
                      xs4
                      class="px-2"
                    >
                      <v-btn
                        @click="convertToSale()"
                        block
                        color="#ed2224"
                        dark
                        :loading="convertToSaleLoading"
                      >
                        Convert To Enquiry
                      </v-btn>
                    </v-flex> -->
                    <v-flex xs4 class="px-1 mb-1">
                      <v-text-field
                        label="Sale"
                        hide-details
                        v-model="formData.salesEnquiry_id"
                        readonly
                      >
                      </v-text-field>
                    </v-flex>
                  </v-layout>
                </v-card-text>
              </v-card>
            </v-flex>
            <!-- Lead Details -->
            <v-flex class="mb-4" xs12 md6>
              <v-card class="ma-2" elevation="5" style="height: 100%">
                <v-toolbar
                  style="font-weight: bold"
                  color="grey darken-2"
                  dense
                  dark
                  class="mb-0"
                >
                  Lead Details
                  <v-spacer></v-spacer>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <span v-on="on" class="pr-2">Order Weight</span>
                    </template>
                    <span
                      >The higher the number, the higher on the list it will be
                      displayed</span
                    >
                  </v-tooltip>
                  <v-select
                    style="max-width: 80px"
                    label=""
                    hide-details
                    light
                    solo
                    v-model="formData.weight"
                    :items="[
                      '0',
                      '1',
                      '2',
                      '3',
                      '4',
                      '5',
                      '6',
                      '7',
                      '8',
                      '9',
                      '10',
                    ]"
                    @change="updateStatus()"
                  ></v-select>
                </v-toolbar>

                <v-card-text>
                  <v-layout row wrap>
                    <v-flex xs6 class="px-1 mb-1">
                      <v-select
                        label="Lead Type"
                        hide-details
                        v-model="formData.leadType"
                        :items="leadTypeList"
                      ></v-select>
                    </v-flex>
                    <!-- <v-flex xs2 class="px-1 mb-1" style="text-align: center">
                      <v-checkbox class="centerCheckbox" hide-details>
                      </v-checkbox>
                      <div>Direct</div>
                    </v-flex>
                    <v-flex xs2 class="px-1 mb-1" style="text-align: center">
                      <v-checkbox
                        class="centerCheckbox"
                        hide-details
                      ></v-checkbox>
                      <div>Their Client</div>
                    </v-flex>
                    <v-flex xs2 class="px-1 mb-1" style="text-align: center">
                      <v-checkbox
                        class="centerCheckbox"
                        hide-details
                        style=""
                      ></v-checkbox>
                      <div>Out Sourcing</div>
                    </v-flex>
                    <v-flex xs2 class="px-1 mb-1" style="text-align: center">
                      <v-checkbox class="centerCheckbox" hide-details>
                      </v-checkbox>
                      <div>Collaborative</div>
                    </v-flex> -->
                    <v-flex xs6 class="px-1 mb-1">
                      <v-autocomplete
                        v-model="formData.user_id"
                        label="Person Responsible (Admin)"
                        :items="staff"
                        item-text="fullName"
                        item-value="id"
                        hide-details
                      >
                      </v-autocomplete>
                    </v-flex>
                    <v-flex xs12 class="px-1 mb-1">
                      <v-slider
                        v-model="formData.chance"
                        always-dirty
                        persistent-hint
                        thumb-label="always"
                        :thumb-size="30"
                        step="10"
                        ticks
                        hide-details
                        label="Chance %"
                      >
                        <template v-slot:thumb-label="item">
                          <span>{{ item.value }}%</span>
                        </template>
                      </v-slider>
                    </v-flex>
                    <v-flex xs6 class="px-1 mb-1" style="background: #fffee0">
                      <v-select
                        label="Est Value (Rev)"
                        :items="estRevList"
                        v-model="formData.estRev"
                        hide-details
                        item-text="desc"
                        item-value="id"
                      ></v-select>
                    </v-flex>
                    <v-flex xs6 class="px-1 mb-1" style="background: #fffee0">
                      <v-select
                        label="Est Contribution ($ UC)"
                        v-model="formData.estCC"
                        hide-details
                        :items="estCCList"
                        item-text="desc"
                        item-value="id"
                      ></v-select>
                    </v-flex>
                    <v-flex xs6 class="px-1 mb-1">
                      <v-text-field
                        label="Actual Value (Rev)"
                        prefix="$"
                        v-model="formData.actRev"
                        hide-details
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs6 class="px-1 mb-1">
                      <v-text-field
                        label="Actuial Contribution  ($ UC)"
                        prefix="$"
                        v-model="formData.actCC"
                        hide-details
                      ></v-text-field>
                    </v-flex>

                    <v-flex xs6 class="px-1 mb-1">
                      <v-text-field
                        label="Most likely Area of Impact"
                        v-model="formData.chosenGoodCause"
                        hide-details
                        readonly
                      >
                      </v-text-field>
                    </v-flex>
                    <v-flex xs6 class="px-1 mb-1">
                      <v-text-field
                        label="Person Connected to Good Cause"
                        v-model="formData.impactLeadConnectionName"
                        hide-details
                        readonly
                      >
                      </v-text-field>
                    </v-flex>
                  </v-layout>
                </v-card-text>
              </v-card>
            </v-flex>
          </v-layout>
        </v-form>
      </v-card-text>
    </v-card>
    <!-- Special Email for IB and AS -->
    <v-dialog v-model="emailIBDialog" persistent>
      <v-card style="min-height: 90vh">
        <v-toolbar
          style="font-weight: bold"
          color="#325181"
          dense
          dark
          class="mb-0"
        >
          Email Impact Buyer
          <v-spacer></v-spacer>
          <v-btn icon dark @click="emailIBDialog = false">
            <v-icon> mdi-close </v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text v-if="!emailIBLoadingPreview">
          <v-form ref="leadsEmailIBForm">
            <v-layout row wrap>
              <v-flex xs12>
                <h3>Quick Preview of Email</h3>
                <p style="font-size: 10pt !important">
                  (*Fonts and certain styles may vary)
                </p>
              </v-flex>

              <v-flex xs12>
                <wysiwyg ref="ibEmailWysiwyg" :html="emailIBObject.body" />
                <!-- <div
                  style="border: 1px solid black; padding: 15px"
                  v-html="emailIBPreview"
                ></div> -->
              </v-flex>

              <v-flex xs4 class="px-2">
                <v-text-field
                  :rules="[(v) => !!v || 'Email To is Required']"
                  label="Email To"
                  hide-details
                  v-model="emailToIB"
                >
                </v-text-field>
              </v-flex>
              <v-flex xs8 class="px-2">
                <v-text-field
                  :rules="[(v) => !!v || 'Email Subject is Required']"
                  label="Subject"
                  hide-details
                  v-model="emailIBObject.subject"
                >
                </v-text-field>
              </v-flex>
              <v-flex xs6 class="px-2">
                <v-combobox
                  label="CC"
                  deletable-chips
                  :items="[]"
                  chips
                  multiple
                  hide-details
                  v-model="emailIBToCC"
                >
                </v-combobox>
              </v-flex>
              <v-flex xs6 class="px-2">
                <v-combobox
                  label="BCC"
                  :items="[]"
                  deletable-chips
                  chips
                  multiple
                  hide-details
                  v-model="emailIBToBCC"
                >
                </v-combobox>
              </v-flex>
              <v-flex xs12>
                <v-btn
                  @click="sendIBEmail()"
                  color="success"
                  :loading="emailIBSending"
                  class="mt-4"
                >
                  Confirm and Send to Impact Business
                </v-btn>
              </v-flex>
            </v-layout>
          </v-form>
        </v-card-text>
        <v-card-text v-else>
          <div style="margin: auto; width: 50px; padding-top: calc(25% - 25px)">
            <v-progress-circular
              :size="50"
              color="primary"
              indeterminate
            ></v-progress-circular>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog v-model="emailASDialog" persistent>
      <v-card style="min-height: 90vh">
        <v-toolbar
          style="font-weight: bold"
          color="#4cc7e8"
          dense
          dark
          class="mb-0"
        >
          Email Supplier
          <v-spacer></v-spacer>
          <v-btn icon dark @click="emailASDialog = false">
            <v-icon> mdi-close </v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text v-if="!emailASLoadingPreview">
          <v-form ref="leadsEmailASForm">
            <v-layout row wrap>
              <v-flex xs12>
                <h3>Quick Preview of Email</h3>
                <p style="font-size: 10pt !important">
                  (*Fonts and certain styles may vary)
                </p>
              </v-flex>

              <v-flex xs12>
                <wysiwyg ref="asEmailWysiwyg" :html="emailASObject.body" />

                <!-- <div
                  style="border: 1px solid black; padding: 15px"
                  v-html="emailASPreview"
                ></div> -->
              </v-flex>
              <v-flex xs4>
                <v-text-field
                  :rules="[(v) => !!v || 'Email To is Required']"
                  label="Email To"
                  v-model="emailToAS"
                >
                </v-text-field>
              </v-flex>
              <v-flex xs8 class="px-2">
                <v-text-field
                  :rules="[(v) => !!v || 'Email Subject is Required']"
                  label="Subject"
                  hide-details
                  v-model="emailASObject.subject"
                >
                </v-text-field>
              </v-flex>
              <v-flex xs6 class="px-2">
                <v-combobox
                  label="CC"
                  deletable-chips
                  :items="[]"
                  chips
                  multiple
                  hide-details
                  v-model="emailASToCC"
                >
                </v-combobox>
              </v-flex>
              <v-flex xs6 class="px-2">
                <v-combobox
                  label="BCC"
                  :items="[]"
                  deletable-chips
                  chips
                  multiple
                  hide-details
                  v-model="emailASToBCC"
                >
                </v-combobox>
              </v-flex>
              <v-flex xs12>
                <v-btn
                  @click="sendASEmail()"
                  color="success"
                  :loading="emailASSending"
                  class="mt-4"
                >
                  Confirm and Send to Supplier
                </v-btn>
              </v-flex>
            </v-layout>
          </v-form>
        </v-card-text>
        <v-card-text v-else>
          <div style="margin: auto; width: 50px; padding-top: calc(25% - 25px)">
            <v-progress-circular
              :size="50"
              color="primary"
              indeterminate
            ></v-progress-circular>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="emailASConfirmContactDialog"
      max-width="600px"
      persistent
    >
      <v-card>
        <v-toolbar
          style="font-weight: bold"
          color="ibColor"
          dense
          dark
          class="mb-0"
        >
          Please confirm buyer contact details... (Buyer details used in Sale
          Enq Card)</v-toolbar
        >
        <v-card-text>
          <v-layout row wrap>
            <v-flex xs12>
              <v-text-field
                label="Contact Person"
                v-model="emailASContactInformation.buyerContactPerson"
              >
              </v-text-field>
            </v-flex>
            <v-flex xs12>
              <v-text-field
                label="Their Email"
                v-model="emailASContactInformation.buyerEmail"
              >
              </v-text-field>
            </v-flex>
            <v-flex xs12>
              <v-text-field
                label="Their Contact #"
                v-model="emailASContactInformation.buyerContactNumber"
              >
              </v-text-field>
            </v-flex>
          </v-layout>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click="emailASConfirmContactDialog = false" dark color="grey"
            >Cancel</v-btn
          >
          <v-btn
            @click="
              emailASConfirmContactDialog = false;
              emailASDialog = true;
              loadASEmailPreview();
            "
            dark
            color="success"
            >Continue</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-card>
</template>

<script>
import { mapGetters } from "vuex";
import Vue from "vue";

import moment from "moment";
import datepicker from "@/components/wrappers/datepicker.vue";
import wysiwyg from "@/components/wrappers/wysiwyg.vue";

export default {
  props: ["formData", "formOpen"],
  components: {
    datepicker,
    wysiwyg,
  },
  data: () => ({
    saving: false,
    deleting: false,

    // Lead Specifics
    leadStatusList: [
      "Card Created",
      "Action Taken",
      "Sounding Positive",
      "Enquiry Created",
      "Sale",
      "Future Follow Up",
      "Already Using",
      "No Opportunity",
    ],
    leadTypeList: ["Direct", "Their Client", "Out Sourcing", "Collaborative"],
    clipboardTextData: "",

    // Future Follow Up
    futureFollowUpDialog: false,
    futureFollowUpDate: null,

    estRevList: [
      {
        id: "1",
        value: 500,
        desc: "< $500",
      },
      {
        id: "2",
        value: 2000,
        desc: "$500 - $2,000",
      },
      {
        id: "3",
        value: 5000,
        desc: "$2,000 - $5,000",
      },
      {
        id: "4",
        value: 10000,
        desc: "$5,000 - $10,000",
      },
      {
        id: "5",
        value: 10000,
        desc: "$10,000 +",
      },
    ],
    estCCList: [
      {
        id: "1",
        value: 100,
        desc: "< $100",
      },
      {
        id: "2",
        value: 200,
        desc: "$100 - $200",
      },
      {
        id: "3",
        value: 500,
        desc: "$200 - $500",
      },
      {
        id: "4",
        value: 1000,
        desc: "$500 - $1,000",
      },
      {
        id: "5",
        value: 1000,
        desc: "$1,000 +",
      },
    ],
    convertToSaleLoading: false,

    // Special Email for IB and AS
    emailIBDialog: false,
    emailIBLoadingPreview: false,
    emailIBObject: {},
    emailIBToCC: [],
    emailIBToBCC: [],
    emailIBSending: false,
    emailToIB: "",

    emailASDialog: false,
    emailASLoadingPreview: false,
    emailASObject: {},
    emailASToCC: [],
    emailASToBCC: [],
    emailASSending: false,
    emailToAS: "",

    emailASConfirmContactDialog: false,
    emailASContactInformation: {},
  }),
  computed: {
    ...mapGetters({
      user: "user",
      userData: "user/userData",
      entities: "impactBusinesses/forLeads",
      suppliers: "business/listOrderedByNameSalesEnquiry",
      staff: "user/staff",
    }),
  },
  watch: {},
  mounted() {},
  methods: {
    save(closeOnSaved = true) {
      this.saving = true;

      for (const [key, value] of Object.entries(this.formData)) {
        if (value == undefined || value == null) {
          delete this.formData[key];
        }
      }

      if (this.formData.hasOwnProperty("id")) {
        this.$store.dispatch("leads/save", this.formData).then(() => {
          if (closeOnSaved) {
            this.$emit("close");
          }
          this.saving = false;
        });
      } else {
        this.formData.user_id = this.userData.id;
        this.$store.dispatch("leads/add", this.formData).then((res) => {
          if (closeOnSaved) {
            this.$emit("close");
          }
          this.saving = false;
        });
      }
    },
    deleteItem() {
      this.$swal
        .fire({
          icon: "warning",
          title: "Are you sure you want to Archive this sale enquiry card?",
          showDenyButton: true,
          showCancelButton: true,
          cancelButtonText: `Don't Archive`,
          confirmButtonText: `Archive`,
          confirmButtonColor: "red",
        })
        .then((result) => {
          /* Read more about isConfirmed, isDenied below */
          if (result.isConfirmed) {
            this.deleting = true;
            this.$store.dispatch("leads/delete", this.formData).then(() => {
              this.deleting = false;
              this.$emit("close");
              this.$swal(
                "Deleted",
                "The Sales Enquiry has been deleted",
                "success"
              );
            });
          }
        });
    },

    updateEntityData() {
      if (
        this.formData.hasOwnProperty("business_id") &&
        this.formData.business_id != ""
      ) {
        let entity = JSON.parse(
          JSON.stringify(
            this.entities.find((e) => e.id == this.formData.business_id)
          )
        );
        this.formData.leadFromType = entity.type;
        this.formData.leadFromName = entity.impactLeadConnectionName;
        this.formData.leadFromPhone = entity.impactPhone;
        this.formData.leadFromEmail = entity.impactEmail;
        this.formData.impactBuyerType = entity.impactBuyerType;
        this.formData.leadFrom_enquiryTotal = entity.enquiryTotal;
        this.formData.leadFrom_revenueTotal = entity.revenueTotal;
        this.formData.leadFrom_cCTotal = entity.cCTotal;
        this.formData.chosenGoodCause = entity.chosenGoodCause;
        this.formData.impactLeadConnectionName =
          entity.impactLeadConnectionName;
      }
    },
    updateSupplierData() {
      if (
        this.formData.hasOwnProperty("leadFor_business_id") &&
        this.formData.leadFor_business_id != ""
      ) {
        let supplier = JSON.parse(
          JSON.stringify(
            this.suppliers.find(
              (s) => s.id == this.formData.leadFor_business_id
            )
          )
        );
        this.formData.callRailPhone = supplier.callRailPhone;
        this.formData.urlKeyword = supplier.urlKeyword;
        this.formData.listTitle = supplier.listTitle;
        this.formData.leadFor_enquiryTotal = supplier.enquiryTotal;
        this.formData.leadFor_revenueTotal = supplier.revenueTotal;
        this.formData.leadFor_cCTotal = supplier.cCTotal;
        this.formData.opportunitySummary = supplier.specificBenefits;
      }
    },
    copyField(data) {
      var copyText = document.querySelector("#clipboardText");
      copyText.value = data;
      copyText.select();
      setTimeout(() => {
        document.execCommand("copy");
        Vue.notify({
          type: "info",
          duration: 2000,
          title: "Copied to Clipboard",
        });
      }, 100);
    },
    updateStatus() {
      switch (this.formData.status) {
        case "Action Taken":
          this.formData.actionTaken = moment().format("YYYY-MM-DD HH:mm:ss");
          this.formData.chance = 20;
          break;

        case "Sounding Positive":
          this.formData.soundingPositive = moment().format(
            "YYYY-MM-DD HH:mm:ss"
          );
          this.formData.chance = 60;
          break;
        case "Sale":
          this.formData.chance = 100;
          break;
        case "Future Follow Up":
          this.formData.chance = 40;
          break;
        case "Slim Chance":
          this.formData.chance = 10;
          break;
        case "No Opportunity":
          this.formData.noOpportunity = moment().format("YYYY-MM-DD HH:mm:ss");
          this.formData.chance = 0;
          break;
        default:
          break;
      }
    },
    formatMoney(amount) {
      if (typeof amount != "undefined" && amount != "") {
        let formatter = new Intl.NumberFormat("en-US", {
          style: "currency",
          currency: "USD",
          minimumFractionDigits: 2,
        });
        return formatter.format(parseInt(amount));
      } else {
        return "$0.00";
      }
    },
    convertToSale(fromASEmail = false) {
      this.convertToSaleLoading = true;

      let salesEnquiryFormData = {
        impactBusiness_id: this.formData.business_id,
        business_id: this.formData.leadFor_business_id,
        fullName: fromASEmail
          ? this.emailASContactInformation.buyerContactPerson
          : this.formData.leadFromName,
        mobile: fromASEmail
          ? this.emailASContactInformation.buyerContactNumber
          : this.formData.leadFromPhone,
        email: fromASEmail
          ? this.emailASContactInformation.buyerEmail
          : this.formData.leadFromEmail,
        via: "Brokered Lead",
        upstreamStatus: "In Progress",
        goodCause_id: this.formData.leadFrom_goodCause_id,
        enquiryAbout: this.formData.leadSummary,
        adminNotes: this.formData.leadNotes,
        actionNeeded: 1,
        personResponsible_user_id: this.formData.user_id,
        businessLeadsInformation_id: this.formData.id,
      };

      this.$store
        .dispatch("business/salesEnquiryAdd", salesEnquiryFormData)
        .then((response) => {
          this.convertToSaleLoading = false;
          this.formData.salesEnquiry_id = response.id;
          this.formData.status = "Enquiry Created";
          this.save(false);
        });
    },
    updateSoundingPositive(date) {
      this.formData.soundingPositive = date;
    },
    updateActionTaken(date) {
      this.formData.actionTaken = date;
    },
    updateCreatedDate(date) {
      this.formData.createdDate = date;
    },
    updateFutureActionDate(date) {
      this.formData.futureActionDate = date;
    },
    updateSlimChance(date) {
      this.formData.slimChance = date;
    },
    updateNoOpportunity(date) {
      this.formData.noOpportunity = date;
    },

    // Special Email for IB and AS
    loadIBEmailPreview() {
      this.emailIBLoadingPreview = true;

      let payload = {
        buyerName: this.formData.name,
        opportunitySummary: this.formData.leadSummary,
        supplierName: this.formData.leadFor_name,
        supplierType: this.formData.listTitle,
        linkToProfileListing: this.formData.leadFor_business_id,
        leadsLinkWithID: this.formData.id,
        buyer_id: this.formData.business_id,
        emailToIB: this.formData.leadFromEmail,
        user: this.userData.fullName,
        replyToEmail: this.userData.email,
      };

      this.$store.dispatch("leads/loadIBEmailPreview", payload).then((res) => {
        this.emailIBLoadingPreview = false;
        this.emailIBObject = res;
        this.emailToIB = res.to[0].email;
      });
    },
    sendIBEmail() {
      if (this.$refs.leadsEmailIBForm.validate()) {
        this.emailIBSending = true;

        this.emailIBObject.body = this.$refs.ibEmailWysiwyg.content;
        this.emailIBObject.to[0].email = this.emailToIB;
        this.emailIBObject.toCC = [];
        this.emailIBObject.toBCC = [];

        this.emailIBToCC.forEach((cc) => {
          this.emailIBObject.toCC.push({ email: cc });
        });

        this.emailIBToBCC.forEach((bcc) => {
          this.emailIBObject.toBCC.push({ email: bcc });
        });

        this.$store
          .dispatch("leads/sendIBEmail", {
            emailData: this.emailIBObject,
            leadID: this.formData.id,
          })
          .then((res) => {
            this.emailIBSending = false;
            Vue.notify({
              type: "info",
              duration: 2000,
              title: "Email Sent",
            });
            this.formData.actionTaken = moment().format("YYYY-MM-DD HH:mm:ss");
            this.formData.chance = 20;
            this.formData.status = "Action Taken";
            this.emailIBDialog = false;
          });
      }
    },
    confirmContactDetailsAS() {
      this.emailASContactInformation = {
        buyerContactNumber: this.formData.leadFromPhone,
        buyerContactPerson: this.formData.impactLeadConnectionName,
        buyerEmail: this.formData.leadFromEmail,
      };
    },
    loadASEmailPreview() {
      this.emailASLoadingPreview = true;

      let payload = {
        supplierName: this.formData.leadFor_name,
        opportunitySummary: this.formData.leadSummary,
        buyerName: this.formData.name,
        buyerType: this.formData.impactBuyerType,
        buyerEmail: this.emailASContactInformation.buyerEmail,
        buyerContactNumber: this.emailASContactInformation.buyerContactNumber,
        leadFor_business_id: this.formData.leadFor_business_id,
        buyerContactPerson: this.emailASContactInformation.buyerContactPerson,
        user: this.userData.fullName,
        replyToEmail: this.userData.email,
      };

      this.$store.dispatch("leads/loadASEmailPreview", payload).then((res) => {
        this.emailToAS = res.to[0].email;
        this.emailASLoadingPreview = false;
        this.emailASObject = res;
      });
    },
    sendASEmail() {
      if (this.$refs.leadsEmailASForm.validate()) {
        this.emailASSending = true;

        this.emailASObject.body = this.$refs.asEmailWysiwyg.content;
        this.emailASObject.to[0].email = this.emailToAS;
        this.emailASObject.toCC = [];
        this.emailASObject.toBCC = [];

        this.emailASToCC.forEach((cc) => {
          this.emailASObject.toCC.push({ email: cc });
        });

        this.emailASToBCC.forEach((bcc) => {
          this.emailASObject.toBCC.push({ email: bcc });
        });

        this.$store
          .dispatch("leads/sendASEmail", { emailData: this.emailASObject })
          .then((res) => {
            this.emailASSending = false;
            Vue.notify({
              type: "info",
              duration: 2000,
              title: "Email Sent",
            });
            this.convertToSale(true);
            this.emailASDialog = false;
          });
      }
    },
  },
  filters: {
    moment: function(date) {
      return moment
        .utc(date)
        .local()
        .format("MMM Do YYYY, h:mm a");
    },
  },
};
</script>

<style lang="css">
.centerCheckbox.v-input.v-input--selection-controls.v-input--checkbox.v-input--hide-details.theme--light {
  width: 25px;
  margin: auto;
}
</style>
